import React from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmationModal from './ConfirmationModal';

interface FormModalsProps {
  showGoBackModal: boolean;
  showRevertModal: boolean;
  onHideGoBackModal: () => void;
  onHideRevertModal: () => void;
  onConfirmGoBack: () => void;
  onConfirmRevert: () => void;
}

const FormModals: React.FC<FormModalsProps> = ({
  showGoBackModal,
  showRevertModal,
  onHideGoBackModal,
  onHideRevertModal,
  onConfirmGoBack,
  onConfirmRevert,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <ConfirmationModal
        show={showGoBackModal}
        title={t("rewardsScreen.modals.backToRewards.title")}
        description={t("rewardsScreen.modals.backToRewards.description")}
        confirmText={t("rewardsScreen.modals.backToRewards.confirm")}
        cancelText={t("productModifyScreen.goBackPopup.cancel")}
        onConfirm={onConfirmGoBack}
        onCancel={onHideGoBackModal}
      />

      <ConfirmationModal
        show={showRevertModal}
        title={t("manageVenuesScreen.revertChangesPopup.title")}
        description={t("manageVenuesScreen.revertChangesPopup.description")}
        confirmText={t("manageVenuesScreen.revertChangesPopup.confirm")}
        cancelText={t("manageVenuesScreen.revertChangesPopup.cancel")}
        onConfirm={onConfirmRevert}
        onCancel={onHideRevertModal}
      />
    </>
  );
};

export default FormModals; 